import { themeGet } from '@styled-system/theme-get'
import { Box, Container, Flex, Hide, Image, Layout, Text } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'
import { StyledHeroImage } from '../HeroModule.style'
import SponsoredBy from '../SponsoredBy/SponsoredBy'
import { getHeroHalfMinHeights, getHeroHalfOverlineImageMaxHeights } from '../utils/utils'

const StyledHero = styled(StyledHeroImage)`
  &&& {
    background-position: ${(props) => props.imageBackgroundFocus};
    min-height: ${(props) => getHeroHalfMinHeights(props.minHeight)[1]};

    @media only screen and (max-width: 768px) {
      min-height: ${(props) => getHeroHalfMinHeights(props.minHeight)[0]};
    }

    &::before {
      border-radius: 24px;
    }
  }
`

const StyledOverlineImage = styled(Image)`
  max-height: ${(props) => getHeroHalfOverlineImageMaxHeights(props.maxHeight)[0]};
  ${themeGet('mediaQueries.lg')} {
    max-height: ${(props) => getHeroHalfOverlineImageMaxHeights(props.maxHeight)[1]};
  }
`

function HeroHalfModule(props) {
  const {
    heading,
    subheading,
    backgroundImage,
    heightDisplayOptions,
    overline,
    overlineImage,
    overlineImageHeightDisplayOptions,
    overlineImagePosition,
    imageGradient,
    mediaDisplayOptions,
    sponsoredByImage,
    textAlign,
    textColor = 'text.dark',
    imageBackgroundFocus = 'center',
  } = props

  const layout = [
    <Box key={0} boxShadowSize={['sm', 'sm', 'lg', 'lg']} borderRadius='2xl'>
      <StyledHero
        borderRadius='2xl'
        borderWidth={0}
        my={[2, 2, 2, 0]}
        image={backgroundImage?.url}
        imageGradient={imageGradient}
        minHeight={heightDisplayOptions}
        imageBackgroundFocus={imageBackgroundFocus}
        {...props}
      />
    </Box>,
    <Flex key={1} height='100%' alignItems='center'>
      <Flex
        my={[2, null, null, 0]}
        flexDirection={overlineImagePosition === 'bottom' ? 'column-reverse' : 'column'}
        style={{ gap: '8px' }}
        textAlign={textAlign}
      >
        {overlineImage?.url && (
          <Box mx={textAlign === 'center' ? 'auto' : 0}>
            <StyledOverlineImage
              alt={overlineImage.altText}
              src={overlineImage.url}
              maxHeight={overlineImageHeightDisplayOptions}
            />
          </Box>
        )}
        <Box>
          {overline && (
            <Text textStyle='overline' color='text.light' mb={2}>
              {overline}
            </Text>
          )}
          <Hide xl xxl>
            {heading && (
              <Text textStyle='heading2' color={textColor} mb={2}>
                {heading}
              </Text>
            )}
            {subheading && (
              <Text textStyle='subheading4' color={textColor}>
                {subheading}
              </Text>
            )}
          </Hide>
          <Hide xs sm md lg>
            {heading && (
              <Text textStyle='title3' color={textColor} mb={2}>
                {heading}
              </Text>
            )}
            {subheading && (
              <Text textStyle='subheading3' color={textColor}>
                {subheading}
              </Text>
            )}
          </Hide>
          {sponsoredByImage?.url && (
            <Flex mt={[3, null, null, 4]} justifyContent={textAlign}>
              {<SponsoredBy {...sponsoredByImage} />}
            </Flex>
          )}
        </Box>
      </Flex>
    </Flex>,
  ]

  return (
    <Container size='xl'>
      <Layout
        variation={['100', null, '50-50']}
        gap={[null, null, 'lg', 'xl']}
        rowGap={['md', 'md', 'sm', 'sm']}
      >
        {mediaDisplayOptions === 'left' ? layout : layout.reverse()}
      </Layout>
    </Container>
  )
}

export default HeroHalfModule
